import type { ReactNode } from 'react'
import { Navigate } from 'react-router'
import { useSession } from '../../hooks/useSession.ts'

/** Someone with a live session has no business on /login — send them to the board. */
export function LoginGate({ children }: { children: ReactNode }): React.JSX.Element | null {
  const session = useSession()

  if (session.isPending) return null
  if (session.data) return <Navigate to="/board" replace />
  return <>{children}</>
}
